import { useAuth } from "@/context/AuthContext";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";
import { Loader2 } from "lucide-react";

export default function AdminPage() {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#060605" }}>
        <Loader2 className="animate-spin" color="#736E63" />
      </div>
    );
  }
  if (!user) return <AdminLogin />;
  return <AdminDashboard />;
}
